import React from 'react';
import { connect } from 'react-redux';
import { StoreSmallItemView } from './store/StoreSmallItemView';

const HomeSearchResults = props => {
    const { filteredStores, placeholderHtml } = props;
    return <>
        {filteredStores.length <= 0 ? <div dangerouslySetInnerHTML={{ __html: placeholderHtml }}></div> :
            <div className="row">
                {filteredStores.map(store =>
                    <div className="columns small-6 medium-4 large-2 store-column" key={store.id}>
                        <StoreSmallItemView store={store}/>
                    </div>
                )}
            </div>
        }
    </>
};

const mapStateToProps = ({ homeSearch: { filteredStores } }) => ({ filteredStores });

export default connect(mapStateToProps, null)(HomeSearchResults);